import React from 'react';
import { Badge } from 'react-bootstrap';

export const getRoleBadgeVariant = (role: string): string => {
  switch (role) {
    case 'admin':
      return 'danger';
    case 'vp_sales':
      return 'primary';
    case 'sales_manager':
      return 'info';
    case 'finance':
      return 'warning';
    case 'events_manager':
      return 'success';
    case 'marketing':
      return 'dark';
    case 'none':
      return 'light';
    default:
      return 'secondary';
  }
};

export const getRoleDisplayName = (role: string): string => {
  switch (role) {
    case 'admin':
      return 'Administrator';
    case 'vp_sales':
      return 'VP Sales';
    case 'sales_manager':
      return 'Sales Manager';
    case 'finance':
      return 'Finance';
    case 'salesperson':
      return 'Salesperson';
    case 'events_manager':
      return 'Events Manager';
    case 'marketing':
      return 'Marketing';
    case 'none':
      return 'No Role';
    default:
      return role || 'User';
  }
};

export const getRoleBadge = (role: string): React.ReactElement => {
  const variant = getRoleBadgeVariant(role);
  const label = getRoleDisplayName(role);
  const textClass = role === 'none' ? 'text-muted' : '';
  return React.createElement(Badge, { bg: variant, className: textClass }, label);
};
